import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import {deleteProjectRfi, getRfis} from "../../../actions/rfis";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import RfiSummary from "./RfiSummary";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr, subdocumentStatusReportSelector, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {compose} from "redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {DeleteButton} from "../DeleteButton";
import UserSmall from "../../Boilerplate/UserSmall";

class RfiList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterKeys: null,
      filterActive: false,
      statusFilter: null,
      error: null,
    };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { rfis } = this.props;
      rfis = rfis || [];
      const options = {
        keys: [
          'resource.title',
          'resource.question',
          'resource.response',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(rfis, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }

  render() {
    let { rfis, project } = this.props;
    rfis = rfis || [];

    const { error } = this.state;
    if (error) return <pre>{error.toString()}</pre>;

    const { filterKeys, filterActive, statusFilter } = this.state;
    if (statusFilter) {
      rfis = rfis.filter(rfi => rfi.resource.status === statusFilter);
    }
    if (filterActive) {
      rfis = rfis.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = rfis.map(i=>i.resource);
    index.sort((a, b) => a.datecreated-b.datecreated);
    index = index.map(i=>i.id);

    return (
      <React.Fragment>
        <Row gutter={16}>
          <Col span={18}>
            <Card>
              <div className="bid-listing-header">
                <h1>RFIs</h1>
                <SearchBox
                  className='control-box control-search'
                  placeholder='search RFIs'
                  onChange={value => this.setFilter(value)}
                />
              </div>
              <Divider/>
              <ExpandedList
                items={rfis}
                index={index}
                derivedKey={item => item.resource.id}
                extra={(<Button type="primary" icon="plus" disabled={!canCreateSub('projectrfi')(project)} onClick={this.props.onNew}>New RFI</Button>)}
                subExtra={<div>
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                </div>}
                renderHeading={() => (
                  <Row className='bid-listing-heading text-column'>
                    <Col span={10}>RFI</Col>
                    <Col span={3}>Created Date</Col>
                    <Col span={6}>Due Date</Col>
                    <Col span={5}>Status</Col>
                  </Row>
                )}
                renderTop={rfi => {
                  let options = [];
                  if (canDelete(rfi)) options.push(<DeleteButton fauxKey={'delete-' + rfi.resource.id} icon='delete'
                    title='Delete Project RFI' document={rfi} onDelete={this.props.onDelete} type='RFI'/>);
                  return (
                    <Row justify='space-between'>
                      <Col span={10}>
                        <NavLink to={rfi.resource.id}>{'#' + rfi.resource.number + ' - ' + rfi.resource.title}</NavLink>
                      </Col>
                      <Col span={3}>
                        <DateDisplay date={rfi.resource.datecreated}/>
                      </Col>
                      <Col span={6}>
                        <DateDisplay date={rfi.resource.duedate}/>
                      </Col>
                      <Col span={2}>
                        <CodeTag
                          code={rfi.resource.status}
                          table={'projectrfistatus'}
                          onClick={() => this.setFilterCode(rfi.resource.status)}
                        />
                      </Col>
                      <Col span={3}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <div>
                            {separatorJoin(options, <span> | </span>)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  );
                }}
                renderContent={rfi => (
                  <React.Fragment>
                    <p>{rfi.resource.description}</p>
                    <p>Created by <UserSmall id={rfi.resource.createdbyuserid}/>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;Assigned to <UserSmall id={rfi.resource.owneruserid}/></p>
                  </React.Fragment>
                )}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <RfiSummary
                title='RFIs by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

RfiList.propTypes = {
  rfis: PropTypes.arrayOf(PropTypes.object),
  statusSummary: PropTypes.array.isRequired,
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'rfis'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const rfis = subViewSelector(state, props);
      const statusSummary = subdocumentStatusReportSelector(state, { path: 'projectrfis', code: 'projectrfistatus' });
      return { rfis, statusSummary, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'rfis']));
        dispatch(getRfis(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/rfis/new`),
      onDelete: (rfiId) => dispatch(deleteProjectRfi(props.match.params.id, rfiId)),
    })),
  withLoading
)(RfiList);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiList.js